var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpsSignal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bce93021-1530-4a10-bc94-5bed7005d344",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e609810f-6db8-4f50-a703-918c53a7c9e8",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8a4,4,0,1,0,4,4A4,4,0,0,0,12,8Zm8.94,3A9,9,0,0,0,13,3.06V1H11V3.06A9,9,0,0,0,3.06,11H1v2H3.06A9,9,0,0,0,11,20.94V23h2V20.94A9,9,0,0,0,20.94,13H23V11ZM12,19a7,7,0,1,1,7-7A7,7,0,0,1,12,19Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsSignal);
export default __webpack_public_path__ + "static/media/gps-signal.6898f9b9591375952af021ddb19f0896.svg";
export { ForwardRef as ReactComponent };